import {
  FormStepFailure,
  FormStepSuccess,
  CreateAccountFailureComponent,
  CreateAccountSuccessComponent,
  MultiStepForm,
  FormStep,
  InputField,
  SelectField,
  PasswordField,
  CheckboxField,
  TelephoneField,
  CountryField,
  CurrencyField,
  DateField,
  UsernameField,
  SSNField,
  FieldReference,
  AddressField,
  INDIA_STATES,
  SelectFieldOption,
  CANADA_PROVINCES_TERRITORIES_WITHOUT_ONTARIO,
  emailRegex,
} from '@whitehatgaming/shared';
import { CreateAccountComponent } from './create-account/create-account.component';

// TODO: (Nice to have) - figure out a nice way to make this easier to make with default options, something like register ['firstname', 'lastName']
// TOOD: (Nice to have) - We need a way to check that all "required" stuff by platform is atleast given... (nice to have though... definitely later date)

export const register: MultiStepForm = new MultiStepForm({
  rootComponent: CreateAccountComponent,

  success: new FormStepSuccess({
    path: 'success',
    component: CreateAccountSuccessComponent,
  }),

  failure: new FormStepFailure({
    path: 'failed',
    component: CreateAccountFailureComponent,
  }),

  steps: [
    new FormStep({
      key: 'personal-details',
      title: '@personal-details-title',
      supportingText: '@personal-details-supporting-text',
      buttonText: '@personal-details-button-text',
      fields: [
        new InputField({
          key: 'firstname',
          label: '@first-name',
          value: '',
          placeholder: '@first-name',
          required: true,
        }),

        new InputField({
          key: 'lastname',
          label: '@last-name',
          placeholder: '@last-name',
          value: '',
          required: true,
        }),

        new SelectField({
          key: 'gender',
          label: '@gender',
          value: '',
          placeholder: '@gender',
          options: [
            { key: 'M', value: '@gender-male' },
            { key: 'F', value: '@gender-female' },
            { key: 'O', value: '@gender-other' },
          ],
        }),

        new DateField({
          key: 'dob',
          label: '@birth-date',
          preText: '@date-format',
          value: '',
          placeholder: '__ /__ /_____',
          required: true,
        }),

        new CountryField({
          key: 'country',
          label: '@country',
          required: true,
          skippedDefaultCountries: ['NL', 'SE'],
        }),

        new SelectField({
          key: 'state',
          label: '@state',
          placeholder: '@please-select',
          required: true,
          conditional: '["CA", "IN"].includes(this.form?.controls.country.value || this.country)',
          options: [],
          jurisdictionOptions: {
            CA: CANADA_PROVINCES_TERRITORIES_WITHOUT_ONTARIO,
            IN: INDIA_STATES,
          },
        }),

        new SSNField({
          key: 'ssn',
          label: '@personal-identity-number',
          value: '',
          preText: '@personal-identity-number-help-text',
          placeholder: '',
        }),

        new InputField({
          key: 'mkgv',
          label: '',
          value: '',
          required: false,
          hidden: true,
          conditional: 'this.country === "CA"',
        }),
      ],
    }),

    new FormStep({
      key: 'address-details',
      buttonText: '@address-details-continue',
      title: '@address-details-title',
      supportingText: '@address-details-supporting-text',
      fields: [
        new InputField({
          key: 'email',
          label: '@email',
          value: '',
          placeholder: '@email',
          required: true,
          type: 'email',
          pattern: emailRegex,
        }),

        new TelephoneField({
          key: 'phone',
          label: '@phone',
          placeholder: '@phone',
          required: true,
          country: new FieldReference('country'),
        }),

        new AddressField({
          key: 'address',
          label: '@address',
          value: '',
          placeholder: {
            lookupKey: '',
            line1Key: '',
            line2Key: '',
            cityKey: '',
            zipCodeKey: '',
          },
          required: true,
        }),
      ],
    }),

    new FormStep({
      key: 'account-details',
      buttonText: '@sign-up',
      title: '@account-details-title',
      supportingText: '@account-details-supporting-text',
      fields: [
        new UsernameField({
          key: 'username',
          label: '@username',
          value: '',
          placeholder: '@username',
          preText: '@username-help-text',
          required: true,
        }),

        new PasswordField({
          key: 'password',
          label: '@password',
          preText: '@password-help-text',
          placeholder: '@password',
          value: '',
          minLength: 8,
          required: true,
          email: new FieldReference('email'),
        }),

        new CurrencyField({
          key: 'currency',
          label: '@currency',
          placeholder: '@currency',
          required: true,
          country: new FieldReference('country'),
        }),

        new CheckboxField({
          key: 'termsPrivacyFunds',
          label: '@terms-and-conditions-privacy-policy-and-funds-policy',
          required: true,
          // jurisdiction: 'UKGC' | 'MGA' | 'SGA' - JurisdictionService.check(country)
        }),

        new CheckboxField({
          key: 'marketingEmails',
          label: '@marketing-emails',
        }),
      ],
    }),
  ],
});
